export class MoovFileDTO{
    public id!: number;
    public customerId!: number;
    public originalFilename!: string;
    public externalFilename!: string;
    public filepath!: string;
    public lineCount!: number;
    public purgeAfter!: string;
    public purgedAt!: string;
    public added!: string;
}